<div id="UserComp" class="content__wrapper">
  <!-- Navtabs -->
  <ul class="nav nav-tabs" [ngClass]="{'create_retail_page':hideUsersNav}">
    <li class="nav-item" [ngClass]="{'ukrainian-width': isUkrainian}">
      <a *ngIf="loginUserRole!='storeUser'" class="nav-link" data-toggle="tab" (click)="setIndex(0)" [ngClass]="{'active': tabIndex === 0}">
        <span *ngIf="!hideUsersNav" i18n="@@users.heading.retailhq-uppercase">RETAIL HQS</span></a>
    </li>
    <li class="nav-item"  *ngIf="!hideUsersNav">
      <a *ngIf="loginUserRole!='storeUser'" class="nav-link" data-toggle="tab" (click)="setIndex(1)" [ngClass]="{'active': tabIndex === 1}">
        <span i18n="@@users.heading.store-uppercase">STORES</span></a>
    </li>
    <li class="nav-item"  *ngIf="!hideUsersNav">
      <a *ngIf="loginUserRole!='storeUser'" class="nav-link" data-toggle="tab" (click)="setIndex(2)" [ngClass]="{'active': tabIndex === 2}">
        <span i18n="@@users.heading.active-users">ACTIVE USERS</span>
      </a>
    </li>
    <!-- <li class="nav-item">
        <a class="nav-link" data-toggle="tab" (click)="setIndex(3)" [ngClass]="{'active': tabIndex === 3}">OEM's</a>
      </li>  -->    
      <li class="nav-item"  *ngIf="!hideUsersNav">
        <a class="nav-link" *ngIf="(loginUserRole =='intelAdmin') || (loginUserRole =='retailHQUser') || (loginUserRole =='regionalHQ')" data-toggle="tab" (click)="setIndex(4)" [ngClass]="{'active': tabIndex === 4}">
          <span i18n="@@users.heading.pending-users">PENDING USERS</span><span class="badge badge-pill badge-danger">{{paginationCount}}</span>
        </a>
      </li> 
      <li class="nav-item"  *ngIf="!hideUsersNav">
        <a *ngIf="loginUserRole!='storeUser' && loginUserRole!='retailHQUser' && loginUserRole!='regionalHQ'" class="nav-link" data-toggle="tab" (click)="setIndex(5)" [ngClass]="{'active': tabIndex === 5}">
          <span i18n="@@domain-whitelist.domain-whitelist-heading-title">DOMAIN ALLOWLIST</span>
        </a>
      </li>
    </ul>
    <div id="userTabContent" class="tab-content">
        <div id="retailHqTab" *ngIf="tabIndex === 0"  class="tab-pane" [ngClass]="{'active': tabIndex === 0, 'create-retail-form':hideUsersNav}">
           <iposcen-retail-hq></iposcen-retail-hq>
        </div>
        <div id="storeTab" *ngIf="tabIndex === 1" class="tab-pane" [ngClass]="{'active': tabIndex === 1}">
           <iposcen-stores></iposcen-stores><!-- include your component here-->
        </div>
        <div id="activeUserTab" *ngIf="tabIndex === 2" class="tab-pane" [ngClass]="{'active': tabIndex === 2}">
           <iposcen-active-users></iposcen-active-users><!-- include your component here-->
         </div>        
         <div id="oemTab" *ngIf="tabIndex === 3" class="tab-pane" [ngClass]="{'active': tabIndex === 3}">
            OEM's <!-- include your component here-->
         </div>        
         <div id="pendingUserTab" *ngIf="tabIndex === 4" class="tab-pane" [ngClass]="{'active': tabIndex === 4}">
            <iposcen-pending-users></iposcen-pending-users>
         </div>        
         <div id="domainWhiteListTab" *ngIf="tabIndex === 5" class="tab-pane" [ngClass]="{'active': tabIndex === 5}">
            <iposcen-domain-whitelist></iposcen-domain-whitelist> <!-- include your component here-->
         </div>        
    </div>
  </div>
  